/**
 * This constant of labels is used in the error component.
 */
export const ErrorLabels = {
    title: 'Cotiza y preevalúa tu crédito en línea',
    firstText: 'Elige el plan de financiamiento que más se adapte a ti y configúralo.',
    secondText: `
        Continua con la preevaluación de tu crédito de una manera rápida y sencilla, solo llena tus 
        datos y en segundos obtendrás un resultado. Estas a un paso de estrenar tu próximo {brand}.
    `
};
